import React, { forwardRef } from 'react'
import PortalModal from '../../../Common/Modal/PortalModal'
import { toast } from 'react-toastify'
import api from '../../../../middleware/api'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

const DeleteMultipleMixturesModal = forwardRef(({ type, mixtures, updateTable }, ref) => {
    const handleDeleteMixtures = async () => {
        const deletedRows = [];
        const deletePromises = mixtures.map(async (row) => {
            try {
                const response = await api.delete(`/mixtures/${type}/delete/${row.id}`);
                if (response.status === 200) {
                    deletedRows.push(row);
                } else {
                    console.log('Error deleting row', row.index);
                }
            } catch (error) {
                console.log('Error deleting row', row.index, error);
            }
        });

        try {
            await Promise.all(deletePromises);
        } catch (error) {
            console.log('Error deleting rows', error);
        }

        const selectedIds = deletedRows.map(row => row.id);
        updateTable(selectedIds)
        ref.current.hideModal();
        toast.success(`${selectedIds.length} Mélange${selectedIds.length > 1 ? 's' : ''} supprimé${selectedIds.length > 1 ? 's' : ''}`, { autoClose: 1000 });
    }

    return (
        <PortalModal className='p-0 max-w-md' ref={ref}>
            <div className='p-6 flex flex-col gap-y-4'>
                <div className='flex items-center gap-3 mb-2'>
                    <div className='bg-error/10 p-2 rounded-full'>
                        <ExclamationTriangleIcon className='h-6 w-6 text-error' />
                    </div>
                    <h2 className='text-lg font-bold'>Confirmer la suppression</h2>
                </div>
                
                <div className='border-t border-b py-4 my-2'>
                    <p className='text-base mb-3'>Êtes-vous sûr de vouloir supprimer les mélanges suivants ?</p>
                    {mixtures.length > 0 &&
                        <ul className='max-h-48 overflow-y-auto pl-6 pr-2 list-disc space-y-1 text-sm text-base-content/80'>
                            {mixtures.map((row, index) => <li key={index}>{row.name}</li>)}
                        </ul>
                    }
                </div>
                
                <p className='text-sm text-error text-center font-medium'>Cette action est irréversible</p>
                
                <div className='flex items-center justify-end gap-3 mt-2'>
                    <button 
                        className='btn btn-ghost' 
                        onClick={() => ref.current.hideModal()}
                    >
                        Annuler
                    </button>
                    <button 
                        className='btn btn-error' 
                        onClick={handleDeleteMixtures}
                    >
                        Supprimer
                    </button>
                </div>
            </div>
        </PortalModal>
    )
})

export default DeleteMultipleMixturesModal
